module.exports = __webpack_public_path__ + "static/media/taxi.c785fec4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/taxi.png
// module id = 54
// module chunks = 0